import classNames from "classnames";
import TrackingService from "@/utils/trackingService";
import styles from "./CtaButtonWithLoader.module.scss";
import { Loader } from "../loader/Loader";

type CtaButtonWithLoaderProps = {
  label: string;
  isFullWidth?: boolean;
  isMarineBg?: boolean;
  isWhiteBg?: boolean;
  onClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  dataCy?: string;
};

export const CtaButtonWithLoader = ({
  label,
  isFullWidth = false,
  isMarineBg = false,
  isWhiteBg = false,
  onClick,
  isLoading = false,
  isDisabled = false,
  dataCy,
}: CtaButtonWithLoaderProps) => (
  <div
    className={classNames(styles.ctaButtonContainer, {
      [styles.fullWidth]: isFullWidth,
      [styles.marineBg]: isMarineBg,
      [styles.whiteBg]: isWhiteBg,
    })}
  >
    <button
      className={classNames(styles.ctaButton, {
        [styles.disabled]: isDisabled,
      })}
      onClick={() => {
        TrackingService.trackCtaClick(label);
        if (onClick && !isLoading && !isDisabled) {
          onClick();
        }
      }}
      data-cy={dataCy}
    >
      {!isLoading && label}
      {isLoading && <Loader className={styles.loader} />}
    </button>
  </div>
);
